
import { ChainId, JSBI, Percent, Token } from '@babydogeswap/sdk'
import { mainnetTokens, testnetTokens } from './tokens'

export const BSC_BLOCK_TIME = 3

export const BASE_BSC_SCAN_URLS = {
  [ChainId.MAINNET]: 'https://bscscan.com',
  [ChainId.TESTNET]: 'https://testnet.bscscan.com'
}

// Dont use bonus router if the bonus is lower than the cutoff
export const BONUS_CUTOFF_AMOUNT = 0.5
// Amount allotted to users, rests goes to wallchain team
export const BONUS_USER_AMOUNT = 0.8
// Manual gas limit set per reccomendation of wallchain team
export const BONUS_GAS_LIMIT = 3000000 // 3 mil

// BABYDOGE_PER_BLOCK details
// 40 BABYDOGE is minted per block
// 20 BABYDOGE per block is sent to Burn pool (A farm just for burning cake)
// 10 BABYDOGE per block goes to BABYDOGE syrup pool
// 9 BABYDOGE per block goes to Yield farms
// BABYDOGE_PER_BLOCK in config/index.ts = 40 as we only change the amount sent to the burn pool which is effectively a farm.
// BABYDOGE/Block in src/views/Home/components/CakeDataRow.tsx = 15 (40 - Amount sent to burn pool)
export const BABYDOGE_PER_BLOCK = 40
export const BLOCKS_PER_YEAR = (60 / BSC_BLOCK_TIME) * 60 * 24 * 365 // 10512000
export const BABYDOGE_PER_YEAR = BABYDOGE_PER_BLOCK * BLOCKS_PER_YEAR
export const BASE_URL = 'https://babydogeswap.com'
export const BASE_ADD_LIQUIDITY_URL = `${BASE_URL}/add`
export const BASE_BSC_SCAN_URL = BASE_BSC_SCAN_URLS[ChainId.MAINNET]
export const DEFAULT_GAS_LIMIT = 200000
export const AUCTION_BIDDERS_TO_FETCH = 500
export const RECLAIM_AUCTIONS_TO_FETCH = 500
export const AUCTION_WHITELISTED_BIDDERS_TO_FETCH = 500
export const IPFS_GATEWAY = 'https://ipfs.io/ipfs'

export const MIDDLEWARE_CONTRACT_TOKENS = [
  // Mainnet
  '0xc748673057861a797275cd8a068abb95a902e8de', // BabyDoge
  '0x28017936E4e95CcAfe2d3d89C222bF470e58965E', // BabyDoge Testnet Token
  '0x733af324146dcfe743515d8d77dc25140a07f9e0', // SHIDO
  '0x2900e6b68658128784b9a1de242f811d938d8ba7', // MUU
  '0x5a5844cab96a7b8b257fc606aa6119c5cbc6d4c4', // BURN
  '0xafb64e73def6faa8b6ef9a6fb7312d5c4c15ebdb', // Grove
  '0xb2fca47c33cc4bf35301b702e21bcdb30e06f079', // Burnt
  '0xadaae082237cb1772c9e079db95c117e6dd0c5af', // Vizla
  '0xDE619A9E0eEeAA9F8CD39522Ed788234837F3B26', // HVI
  '0x837a130aed114300bab4f9f1f4f500682f7efd48', // WSI
]

export const LOCAL_ASSETS_ADDRESSES = [
  mainnetTokens.usdt.address, // USDT Token
  '0xed00fc7d48b57b81fe65d1ce71c0985e4cf442cb' // CHRP Token
]

export enum RouterTypes {
  BABYDOGE_V2 = 'BABYDOGE V2',
  BABYDOGE_V3 = 'BABYDOGE V3',
  SMART = 'SMART',
  BONUS = 'BONUS',
}

export const INVALID_TOKEN_LIST = [
  '0x55d398326f99059fF775485246999027B3197955',
  '0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56',
  '0xE6E2DF35c8dBd16cdBA3287E6D4C5BEbD7CFFd3a', // testnet
  '0xd40E537f03784acB707F6524fb6a6aAb5f8e663c', // testnet
  '0x26A50e3FdF19657eB917B8ACAEa1bDa19f1C3f85', // testnet
]

// a list of tokens by chain
type ChainTokenList = {
  readonly [chainId in ChainId]: Token[]
}

// used to construct intermediary pairs for trading
export const BASES_TO_CHECK_TRADES_AGAINST: ChainTokenList = {
  [ChainId.MAINNET]: [
    mainnetTokens.wbnb,
    mainnetTokens.usdt,
    mainnetTokens.usdc,
    mainnetTokens.busd,
    mainnetTokens.bnb,
    mainnetTokens.btcb,
    mainnetTokens.eth,
  ],
  [ChainId.TESTNET]: [
    testnetTokens.wbnb,
    testnetTokens.usdt,
    testnetTokens.usdc,
    testnetTokens.busd,
    testnetTokens.bnb,
    testnetTokens.btcb,
    testnetTokens.eth,
  ],
  [ChainId.ETHEREUM_MAINNET]: [
    testnetTokens.wbnb,
    testnetTokens.usdt,
    testnetTokens.usdc,
    testnetTokens.busd,
    testnetTokens.bnb,
    testnetTokens.btcb,
    testnetTokens.eth,
  ],
  [ChainId.POLYGON_MAINNET]: [
    testnetTokens.wbnb,
    testnetTokens.usdt,
    testnetTokens.usdc,
    testnetTokens.busd,
    testnetTokens.bnb,
    testnetTokens.btcb,
    testnetTokens.eth,
  ],
  [ChainId.POLYGON_TESTNET]: [
    testnetTokens.wbnb,
    testnetTokens.usdt,
    testnetTokens.usdc,
    testnetTokens.busd,
    testnetTokens.bnb,
    testnetTokens.btcb,
    testnetTokens.eth,
  ],
  [ChainId.ARBITRUM_TESTNET]: [
    testnetTokens.wbnb,
    testnetTokens.usdt,
    testnetTokens.usdc,
    testnetTokens.busd,
    testnetTokens.bnb,
    testnetTokens.btcb,
    testnetTokens.eth,
  ],
}

/**
 * Additional bases for specific tokens
 * @example { [WBTC.address]: [renBTC], [renBTC.address]: [WBTC] }
 */
export const ADDITIONAL_BASES: { [chainId in ChainId]?: { [tokenAddress: string]: Token[] } } = {
  [ChainId.MAINNET]: {},
}

/**
 * Some tokens can only be swapped via certain pairs, so we override the list of bases that are considered for these
 * tokens.
 * @example [AMPL.address]: [DAI, WETH[ChainId.MAINNET]]
 */
export const CUSTOM_BASES: { [chainId in ChainId]?: { [tokenAddress: string]: Token[] } } = {
  [ChainId.MAINNET]: {},
}

// used for display in the default list when adding liquidity
export const SUGGESTED_BASES: ChainTokenList = {
  [ChainId.MAINNET]: [
    mainnetTokens.babydoge,
    mainnetTokens.btcb,
    mainnetTokens.usdt,
    mainnetTokens.usdc,
    mainnetTokens.busd,
    mainnetTokens.eth,
  ],
  [ChainId.TESTNET]: [
    testnetTokens.babydoge,
    testnetTokens.btcb,
    testnetTokens.usdt,
    testnetTokens.usdc,
    testnetTokens.busd,
    testnetTokens.eth,
  ],
  [ChainId.ETHEREUM_MAINNET]: [
    testnetTokens.babydoge,
    testnetTokens.btcb,
    testnetTokens.usdt,
    testnetTokens.usdc,
    testnetTokens.busd,
    testnetTokens.eth,
  ],
  [ChainId.POLYGON_TESTNET]: [
    testnetTokens.babydoge,
    testnetTokens.btcb,
    testnetTokens.usdt,
    testnetTokens.usdc,
    testnetTokens.busd,
    testnetTokens.eth,
  ],
  [ChainId.POLYGON_MAINNET]: [
    testnetTokens.babydoge,
    testnetTokens.btcb,
    testnetTokens.usdt,
    testnetTokens.usdc,
    testnetTokens.busd,
    testnetTokens.eth,
  ],
  [ChainId.ARBITRUM_TESTNET]: [
    testnetTokens.babydoge,
    testnetTokens.btcb,
    testnetTokens.usdt,
    testnetTokens.usdc,
    testnetTokens.busd,
    testnetTokens.eth,
  ],
}

// used to construct the list of all pairs we consider by default in the frontend
export const BASES_TO_TRACK_LIQUIDITY_FOR: ChainTokenList = {
  [ChainId.MAINNET]: [mainnetTokens.bnb, mainnetTokens.btcb],
  [ChainId.TESTNET]: [testnetTokens.bnb, testnetTokens.btcb],
  [ChainId.ETHEREUM_MAINNET]: [testnetTokens.bnb, testnetTokens.btcb],
  [ChainId.POLYGON_MAINNET]: [testnetTokens.bnb, testnetTokens.btcb],
  [ChainId.POLYGON_TESTNET]: [testnetTokens.bnb, testnetTokens.btcb],
  [ChainId.ARBITRUM_TESTNET]: [testnetTokens.bnb, testnetTokens.btcb],
}

export const PINNED_PAIRS: { readonly [chainId in ChainId]?: [Token, Token][] } = {
  [ChainId.MAINNET]: [[mainnetTokens.bnb, mainnetTokens.busd]],
}

// default allowed slippage, in bips
export const INITIAL_ALLOWED_SLIPPAGE = 50
// default allowed slippage, in bips
export const BABYDOGE_ALLOWED_SLIPPAGE = 1200
// 20 minutes, denominated in seconds
export const DEFAULT_DEADLINE_FROM_NOW = 60 * 20

export const MAX_HOPS = 3

export const BIG_INT_ZERO = JSBI.BigInt(0)

// one basis point
export const ONE_BIPS = new Percent(JSBI.BigInt(1), JSBI.BigInt(10000))
export const BIPS_BASE = JSBI.BigInt(10000)

export const SMART_ROUTER_PRICE_THRESH_HOLD: Percent = new Percent(JSBI.BigInt(1000), BIPS_BASE) // < 10%
// used for warning states
export const ALLOWED_PRICE_IMPACT_LOW: Percent = new Percent(JSBI.BigInt(100), BIPS_BASE) // 1%
export const ALLOWED_PRICE_IMPACT_MEDIUM: Percent = new Percent(JSBI.BigInt(300), BIPS_BASE) // 3%
export const ALLOWED_PRICE_IMPACT_HIGH: Percent = new Percent(JSBI.BigInt(500), BIPS_BASE) // 5%
// if the price slippage exceeds this number, force the user to type 'confirm' to execute
export const PRICE_IMPACT_WITHOUT_FEE_CONFIRM_MIN: Percent = new Percent(
  JSBI.BigInt(1000),
  BIPS_BASE,
) // 10%
// for non-expert mode disable swaps above this
export const BLOCKED_PRICE_IMPACT_NON_EXPERT: Percent = new Percent(JSBI.BigInt(1500), BIPS_BASE) // 15%

// used to ensure the user doesn't send so much BNB, so they end up with <.01
export const MIN_BNB: JSBI = JSBI.exponentiate(JSBI.BigInt(10), JSBI.BigInt(16)) // .01 BNB
export const BETTER_TRADE_LESS_HOPS_THRESHOLD = new Percent(JSBI.BigInt(50), JSBI.BigInt(10000))

export const ZERO_PERCENT = new Percent('0')
export const ONE_HUNDRED_PERCENT = new Percent('1')

export const BASE_FEE = new Percent(JSBI.BigInt(30), BIPS_BASE)
export const INPUT_FRACTION_AFTER_FEE = ONE_HUNDRED_PERCENT.subtract(BASE_FEE)

// SDN OFAC addresses
export const BLOCKED_ADDRESSES: string[] = [
  '0x7F367cC41522cE07553e823bf3be79A889DEbe1B',
  '0xd882cFc20F52f2599D84b8e8D58C7FB62cfE344b',
  '0x901bb9583b24D97e995513C6778dc6888AB6870e',
  '0xA7e5d5A720f06526557c513402f2e6B5fA20b008',
  '0x8576aCC5C05D6Ce88f4e49bf65BdF0C62F91353C',
]

export const FAST_INTERVAL = 10000
export const SLOW_INTERVAL = 60000

// zero fee pairs
export const ZERO_FEE_PAIRS = ['0x0536c8b0c3685b6e3c62a7b5c4e8b83f938f12d1']

export const API_KEY_RAMPER = 'pk_prod_9gc0IwZZO25jzXOmPVtvU7kkWwUqtNjsooDC90e5AIo0'
